import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  titleObj:any = {};
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.titleObj =  this.route.snapshot.firstChild.data;
  }

}
